export interface ClientDocumentModel {
  clientId: string
  categoryId: number
  typeId: number
  file: string | ArrayBuffer
  filename: string
  number: string | null
  personalIdNumber: string | null
  countryId: string | null
  expirationAt?: Date | string | null
  statusId?: DocumentStatusId | null
}

export enum DocumentStatusId {
  APPROVED = 2,
  REJECTED = 3,
}

export enum DocumentTypeId {
  BankStatement = 11,
  ProofOfDeposit = 48,
}

export interface ClientDocumentType {
  id: number
  name: string
}

export interface CategoryType {
  id: number
  name: string
}

export interface TagType {
  id: number
  name: string
}

export interface StatusType {
  id: number
  name: string
}

export interface DocumentStatus {
  id: number // id = 5 | Deleted
  name: string
}

enum DocumentStatusType {
  Rejected = 3,
  Deleted = 5,
}

export const isDocumentStatusDeleted = (documentStatus?: DocumentStatusType): boolean => {
  return documentStatus === DocumentStatusType.Deleted
}

export const isDocumentSanitized = (documentId: string): boolean =>
  documentId === '00000000-0000-0000-0000-000000000000'

export const isDocumentStatusRejected = (documentStatus: DocumentStatusType): boolean => {
  return documentStatus === DocumentStatusType.Rejected
}

export interface DocumentRelationType {
  id: number
  name: string
}

export const documentRelations = [
  { id: 0, name: 'None' },
  { id: 1, name: 'Translation' },
]

export enum DocumentCategoryType {
  None = 0,
  Personal = 1,
  Address = 2,
  Corporate = 3,
  Additional = 7,
  Internal = 8,
  AppropriatenessTest = 9,
  PaymentAgent = 10,
  Migrated = 11,
  Statements = 12,
  Payments = 13,
}

export const isDocumentCategoryPersonal = (documentCategoryType: DocumentCategoryType): boolean => {
  return documentCategoryType === DocumentCategoryType.Personal
}

export const isNotifyClientAllowedByCategoryType = (
  documentCategoryType: DocumentCategoryType
): boolean => {
  return [DocumentCategoryType.Personal, DocumentCategoryType.Address].includes(
    documentCategoryType
  )
}

export interface UpdateClientDocument extends UpdateClientFullNameAndDateOfBirth {
  id: string
  categoryId: string
  number: string | null
  personalIdNumber: string | null
  typeId: number
  statusId: string
  expirationAt: string | null
  relations: UpdateRelation[] | null
  tags: number[]
  countryId: string | null
}

export interface UpdateClientFullNameAndDateOfBirth {
  fullName?: {
    firstName: string
    middleName: string
    lastName: string
  }
  dateOfBirth?: string
}

export interface UpdateRelation {
  documentId: string
  typeId: 1
}

export interface MassDocumentCategoryUpdateDto {
  documentIds: string[]
  categoryId: number
  typeId: number
}
